import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import CheckMarkSVG from '../../assets/svg/checkmark.svg'
import { useGetPeoplePlans } from '../../redux/human-resources/hook/subscription'
import LoadingBar from '../loader-bar'
import SelectSubscriptionPlan from '../modal/hr-section/subscription/select-subscription'
import { useGetEmployeeSummary } from '../../redux/employees/hook'
import Button from '../button'

const PeoplePlans = () => {
  useEffect(() => {}, [])
  const { section } = useSelector((state) => state.sectionSlice)

  const { data: people_plans, isLoading } = useGetPeoplePlans()
  const { data: getEmployeeSummary } = useGetEmployeeSummary()

  const [showSelectSubscriptionPlan, setShowSelectSubscriptionPlan] =
    useState(false)
  const [subscriptionData, setSubscriptionData] = useState(null)
  const [activeTab, setActiveTab] = useState('monthly')

  const features = [
    'Attendance',
    'Performance Management',
    'Leave Management',
    'Queries',
    'Suspension',
    'Announcements',
    'Goals',
    'Employee Cabinet',
    'Employee Mobile/Web App',
    'Guarantors',
    'Employee Onboarding',
    'Employee Exit',
  ]

  // Plan data structure based on the image
  const monthlyPlan = {
    name: 'Monthly Plan',
    price: '#1,000',
    perEmployee: true,
    features: features.map(() => true), // All features included
    action: () => {
      setSubscriptionData(people_plans?.[0])
      setShowSelectSubscriptionPlan(true)
    },
  }

  const annualPlan = {
    name: 'Annual Plan',
    price: '#10,000',
    perEmployee: true,
    features: features.map(() => true), // All features included
    action: () => {
      setSubscriptionData(people_plans?.[1])
      setShowSelectSubscriptionPlan(true)
    },
  }

  const PlanCard = ({ plan }) => {
    return (
      <div
        className={classNames(
          'flex flex-col w-full md:w-[48%] border border-gray-200 bg-white p-6 ',
        )}
      >
        {/* Plan Header */}
        <div className='flex justify-between items-center mb-4'>
          <h3 className='text-lg font-semibold text-gray-800'>{plan.name}</h3>
        </div>

        {/* Price */}
        <div className='mb-6'>
          <span className='text-3xl font-bold text-gray-900'>{plan.price}</span>
          <span className='text-sm text-gray-500 ml-1'>per employee</span>
        </div>

        {/* Select Plan Button */}
        <Button
          text='Select Plan'
          type='button'
          textClass={'!text-[13px] font-medium'}
          onClick={() => {
            plan.action()
          }}
        />

        {/* Features Section */}
        <div className='border-t border-gray-100 pt-4'>
          <h4 className='text-sm font-semibold text-gray-700 mb-3'>Features</h4>
          <div className='space-y-4'>
            {features.map((feature, index) => (
              <div
                key={index}
                className='flex items-cebter justify-between gap-2.5'
              >
                <span className='text-sm text-gray-600'>{feature}</span>
                <img
                  src={CheckMarkSVG}
                  alt='check'
                  className='w-4 h-4 mt-0.5 flex-shrink-0'
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='flex flex-col '>
      {showSelectSubscriptionPlan ? (
        <SelectSubscriptionPlan
          isOpen={showSelectSubscriptionPlan}
          closeModal={() => setShowSelectSubscriptionPlan(false)}
          subscriptionData={subscriptionData}
        />
      ) : null}

      {isLoading ? (
        <div className='flex flex-col w-full text-center justify-center pb-[25px] pt-[5px]'>
          <LoadingBar loading={isLoading} />
        </div>
      ) : (
        <>
          <div className='flex flex-col md:flex-row gap-6 justify-center items-stretch'>
            <PlanCard plan={monthlyPlan} />
            <PlanCard plan={annualPlan} />
          </div>
        </>
      )}
    </div>
  )
}

export default PeoplePlans
